import { render, staticRenderFns } from "./Kf.vue?vue&type=template&id=22ba8e3f&scoped=true"
import script from "./Kf.vue?vue&type=script&lang=js"
export * from "./Kf.vue?vue&type=script&lang=js"
import style0 from "./Kf.vue?vue&type=style&index=0&id=22ba8e3f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22ba8e3f",
  null
  
)

export default component.exports